import { setPoseidonBuilder } from "@stealthos/sdk";

// Register a bundler-visible ESM import before any SDK hashing is requested.
// SDK initialization remains lazy and shared across all private-spend paths.
setPoseidonBuilder(async () => {
  const { buildPoseidon } = await import("circomlibjs");
  return buildPoseidon();
});

export * from "@stealthos/sdk";
